import React, {useState} from 'react';
import {Link, useNavigate} from 'react-router-dom'; // Importa useNavigate
import {Modal, Button, Form} from 'react-bootstrap';
import {useModal} from '../backend/ModalContext';
import useCsrfToken from '../backend/useCsrfToken';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Header.css';

function Header() {
    const {isModalOpen, openModal, closeModal} = useModal();
    const navigate = useNavigate(); // Usa useNavigate

    const isInIframe = window.self !== window.top;
    const logoLink = isInIframe ? '/' : 'https://psicopatici.com';

    return (
        <>
            <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false}/>

            <Navbar
                collapseOnSelect
                expand="lg"
                className="navbar-custom"
                style={{
                    position: "fixed",
                    top: 0,
                    width: "100%",
                    zIndex: 1000,
                    backgroundColor: "#000",
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.2)",
                }}
            >
                <Container className="d-flex align-items-canter">
                    {/* Se non siamo in un iframe, mostriamo il menu completo */}
                    {!isInIframe && (
                        <Nav className="mx-auto d-flex justify-content-center w-100">
                            <Link className="navbar-brand m-0 d-flex align-items-center justify-content-center"
                                  to={logoLink}>
                                <img
                                    style={{width: '200px',maxWidth: '200px'}}
                                    src="https://cdn.psicopaticiservice.com/logo/materialeweb/logo-white.png"
                                    alt="logo"
                                />
                            </Link>
                        </Nav>
                    )}

                </Container>
            </Navbar>

            {/* Modal e altri componenti */}
            <Modal show={isModalOpen} onHide={closeModal} fullscreen className="custom-modal">
                <Modal.Header closeButton style={{borderBottom: 'none', position: 'relative'}}>
                    <Modal.Title>Diventa Partner - Step {/* Inserisci step qui */}</Modal.Title>
                    <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={closeModal}
                        style={{
                            position: 'absolute',
                            right: '15px',
                            top: '15px',
                            zIndex: 10,
                            fontSize: '1.5rem',
                        }}
                    >
                        ×
                    </button>
                </Modal.Header>
                <Modal.Body>
                    {/* Inserisci qui il contenuto del form */}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary">Indietro</Button>
                    <Button variant="primary">Avanti</Button>
                    <Button variant="success">Invia</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default Header;
